
import { useStaging } from "../libs/firebase.js";
import { zeroDecimalCurrencies } from "ui";

export const stripeProcessorURL = useStaging ? 'https://us-central1-mattoboard-staging.cloudfunctions.net/StripeProcessor5' : 'https://us-east1-mattoboard-b8284.cloudfunctions.net/StripeProcessor5';

export const cancelStripeSubscriptionAPIUrl = stripeProcessorURL + '/cancelStripeSubscription';
export const getStripeSetupIntentAPIUrl = stripeProcessorURL + '/createPaymentIntent';
export const getStripePaymentIntentAPIUrl = stripeProcessorURL + '/createImmediatePaymentIntent';
export const getStripeInvoicesAPIUrl  = stripeProcessorURL + '/getStripeInvoice';
export const createStripeSubscriptionAPIUrlV3 =   stripeProcessorURL + '/createSubscriptionV3';
export const createStripeSubscriptionAPIUrlV4 =   stripeProcessorURL + '/createSubscriptionV4';
export const createTeamSubscriptionAPIUrl =   stripeProcessorURL + '/createTeamSubscription';
export const updateTeamSubscriptionSeatsAPIUrl = stripeProcessorURL + '/updateTeamSubscriptionSeats';
export const getSubscriptionAPIUrl  = stripeProcessorURL + '/getSubscription';
export const revertStripeSubscriptionAPIUrl = stripeProcessorURL + '/revertStripeSubscription';
// Billing recovery (issue #3956): Customer Portal session in the
// payment_method_update flow for the signed-in user (Firebase id token).
export const createCardUpdateSessionAPIUrl = stripeProcessorURL + '/createCardUpdateSession';
// Pause instead of cancel (issue #3957). Both require a Firebase ID token.
export const pauseStripeSubscriptionAPIUrl = stripeProcessorURL + '/pauseStripeSubscription';
export const resumeStripeSubscriptionAPIUrl = stripeProcessorURL + '/resumeStripeSubscription';
// Self-serve account deletion (issue #3824). Soft delete: cancels Stripe and
// disables login immediately; Firestore data is purged 30 days later by the
// purgeDeletedAccounts scheduled job. Requires a Firebase ID token.
export const requestAccountDeletionAPIUrl = stripeProcessorURL + '/requestAccountDeletion';
export const getPricesAndLocationsAPIUrl = stripeProcessorURL + '/getPricesAndLocation';
// NOTE: getCreditPricesAndLocationAPIUrl has been moved to packages/ui
// Import from "ui" package instead: import { getCreditPricesAndLocationAPIUrl } from "ui";
export const checkPromoCodeAPIUrl = stripeProcessorURL + '/checkPromoCode';

export const getPriceURL = stripeProcessorURL + '/getPrices';

// Re-export from ui for backwards compatibility with subscription code
export { publishableKey, getStripePitchImage } from "ui";



// local_price is Stripe minor units except for zero-decimal currencies. Returns a
// number — formatPrice() gives an en-US string ("1,299.00") GA4 and Meta can't parse.
export const getPriceMajorUnits = (profilePrices) => {
    const minor = Number(profilePrices?.local_price)
    if (!Number.isFinite(minor)) return null
    const currency = String(profilePrices?.currency || 'usd').toLowerCase()
    const major = zeroDecimalCurrencies.includes(currency) ? minor : minor / 100
    return Math.round(major * 100) / 100
}

// Meta Pixel `Purchase` params (standard event parameter names).
export const getMetaPurchaseParams = (profilePrices) => {
    const value = getPriceMajorUnits(profilePrices)
    if (value === null || !profilePrices?.currency) return null
    return { value, currency: String(profilePrices.currency).toUpperCase(),
             content_type: 'product', content_ids: [profilePrices.priceID],
             content_name: 'Mattoboard Pro Subscription', num_items: 1 }
}

export const getGoogleAnalyticsProductInfo = (profilePrices) => {
    const price = getPriceMajorUnits(profilePrices)
    return  {  currency: profilePrices.currency, value: price,
            items: [ { id: profilePrices.priceID,name: "Mattoboard Pro Subscription",category: "subscription",
                quantity: 1,price:price   } ]
      }
}